import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	inviteTeammateButton: {
		id: 'business-summary.summary-view.workload-by-assignee.invite-teammate.invite-teammate-button.invite-teammate-button',
		defaultMessage: 'Invite teammate',
		description: 'Invite teammate button text',
	},
});
